<template>
  <BlocksCard class="description-block" :class="{'--showing-more': isViewMore}">
    <h2 class="__heading">
      {{ title }}
    </h2>
    <div class="description-block__inner" :style="!isViewMore ? `max-height: 360px;` : ''">
      <p v-if="content" v-html="formatTextAreaContent(content || '')" />
      <div id="fadeOverlay" class="fade" />
    </div>
    <div class="__view-more-btn" @click="isViewMore = !isViewMore">
      See {{ isViewMore ? 'Less' : 'More' }}
      <img v-lazy-load  :data-src="chevron" alt="Down arrow icon">
    </div>
  </BlocksCard>
</template>

<script lang="ts" setup>
import {PropType} from 'vue';
import chevron from '~/assets/images/icons/chevron-down.webp';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  content: {
    type: [String, null] as PropType<string | null>,
    default: '',
  },
});

const isViewMore: Ref<boolean> = ref(false);
</script>

<style lang="scss">
.description-block {

  &__inner {
    max-height: fit-content;
    overflow-y: hidden;
    position: relative;
    margin-bottom: 20px;

    .fade {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 80px; /* Increased height */
      background-image: linear-gradient(to bottom, rgba(255,255,255,0), white 90%);
    }
  }

  .__view-more-btn {
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: rgb(var(--text-dark));
    cursor: pointer;
    transform: scale(1);
    transition: all 0.2s ease-in-out;

    img {
      width: 15px;
      margin-left: 4px;
      transition: all 0.2s ease-in-out;
    }

    &:hover {
      transform: scale(1.05);
      transition: all 0.2s ease-in-out;
    }
  }

  &.--showing-more {
    .description-block__inner {
      .fade {
        height: 0;
      }
    }

    .__view-more-btn {
      img {
        transform: rotate(180deg);
        transition: all 0.2s ease-in-out;
      }
    }
  }
}
</style>
